import React, { useContext, useState } from 'react';
import { Button, Flex } from 'antd';

import GenericTenantRefreshDialog from '@totem/components/settings/sections/mappingsRefresh/genericTenantRefreshDialog';
import ZoneMappingContainer from '@totem/components/settings/sections/nozomi/zoneMappings/ZoneMappingContainer';
import ZoneMappingContext from '@totem/components/settings/sections/nozomi/zoneMappings/ZoneMappingContext';
import ZoneMappingTable from '@totem/components/settings/sections/nozomi/zoneMappings/ZoneMappingTable';
import ZoneSearch from '@totem/components/settings/sections/nozomi/zoneMappings/zoneSearch';
import IBDIcon from '@totem/styles/Icon';
import { NOZOMI_ENDPOINT } from '@totem/utilities/endpoints';

import '../../../settings.css';

const NozomiMappingPanelContent = ({
  refreshingTenants,
  onClose,
}: {
  refreshingTenants: boolean;
  onClose: () => void;
}) => {
  const { onActionComplete } = useContext(ZoneMappingContext);

  return (
    <>
      <ZoneMappingTable />
      <GenericTenantRefreshDialog
        toolName={'Nozomi'}
        apiEndpoint={`${NOZOMI_ENDPOINT}/tenant/refresh`}
        onActionComplete={() => onActionComplete(true)}
        open={refreshingTenants}
        onClose={onClose}
      />
    </>
  );
};

const ZoneMappingPanel = () => {
  const [refreshingTenants, setRefreshingTenants] = useState<boolean>(false);

  return (
    <div styleName="container">
      <div styleName="header-container">
        <div styleName="header">Zone Mapping</div>
        <div>
          <Button
            title={'Refresh'}
            size={'small'}
            shape={'square'}
            onClick={() => setRefreshingTenants(true)}
            icon={
              <IBDIcon
                style={{
                  color: '#BBBBBB',
                }}
                name={'Refresh'}
              />
            }
          >
            Refresh
          </Button>
        </div>
      </div>
      <ZoneMappingContainer>
        <Flex
          justify={'flex-start'}
          align={'center'}
          style={{ marginBottom: '8px' }}
        >
          <ZoneSearch />
        </Flex>
        <NozomiMappingPanelContent
          refreshingTenants={refreshingTenants}
          onClose={() => setRefreshingTenants(false)}
        />
      </ZoneMappingContainer>
    </div>
  );
};

export default ZoneMappingPanel;
